import actionCreatorFactory from 'typescript-fsa';

import { ModalPayload } from '@topconagriculture/modal';

import reduxConfig from '../config';
import { ModalsNames } from '../../config/modals/modalNames';
import { LoadersNames, SidebarNames, TabsNames } from './ui.constants';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/ui');

export const openModal = actionCreator<ModalPayload>('SHOW_MODAL');
export const openSideModal = actionCreator<ModalsNames>('SHOW_SIDE_MODAL');
export const closeAllModals = actionCreator('CLOSE_MODAL');

export const showLoader = actionCreator<LoadersNames>('SHOW_LOADER');
export const hideLoader = actionCreator<LoadersNames>('HIDE_LOADER');

export const setRedirectPath = actionCreator<string | null>('SET_REDIRECT_PATH');
export const resetRedirectPath = actionCreator('RESET_REDIRECT_PATH');

export const setActiveTabIndex = actionCreator<{
  tabIndex: number;
  tabName: string;
  tabNamespace: TabsNames;
}>('SET_ACTIVE_TAB_INDEX');
export const setSidebarVisibility = actionCreator<{ sidebarName: SidebarNames; isVisible: boolean }>(
  'SET_SIDEBAR_VISIBILITY',
);

export const setEditGroupPropertyTooltipName = actionCreator<string | null>('OPEN_EDIT_POPUP');
export const setFeedingListVisited = actionCreator<boolean>('SET_FEEDING_LIST_VISITED');
export const setFeedingListFormIsChanged = actionCreator<boolean>('SET_FEEDING_LIST_FORM_IS_CHANGED');
